import { MessageDirection } from "client/openapi";
import { Select } from "components/Select";

type DirectionFilter = "all" | MessageDirection;
export type ChannelFilter = "all" | "sms" | "email" | "internal";

const directionOptions: { value: DirectionFilter; label: string }[] = [
  { value: "all", label: "All" },
  { value: MessageDirection.INBOUND, label: "Inbound" },
  { value: MessageDirection.OUTBOUND, label: "Outbound" },
];

const channelOptions: { value: ChannelFilter; label: string }[] = [
  { value: "all", label: "All" },
  { value: "sms", label: "Text" },
  { value: "email", label: "Email" },
  { value: "internal", label: "Internal Log" },
];

export function CommunicationFilters({
  directionFilter,
  setDirectionFilter,
  channelFilter,
  setChannelFilter,
}: {
  directionFilter: DirectionFilter;
  setDirectionFilter: (val: DirectionFilter) => void;
  channelFilter: ChannelFilter;
  setChannelFilter: (val: ChannelFilter) => void;
}) {
  const labelClasses = "mr-2 text-sm font-medium whitespace-nowrap";

  return (
    <div className="flex flex-col md:flex-row gap-4">
      <div className="flex items-center gap-2">
        <label className={labelClasses}>Direction:</label>
        <div style={{ minWidth: 160 }}>
          <Select
            options={directionOptions}
            value={directionOptions.find((o) => o.value === directionFilter)}
            onChange={(selected) =>
              setDirectionFilter(selected ? selected.value : "all")
            }
            placeholder="All"
          />
        </div>
      </div>

      <div className="flex items-center gap-2">
        <label className={labelClasses}>Channel:</label>
        <div style={{ minWidth: 160 }}>
          <Select
            options={channelOptions}
            value={channelOptions.find((o) => o.value === channelFilter)}
            onChange={(selected) =>
              setChannelFilter(selected ? selected.value : "all")
            }
            placeholder="All"
          />
        </div>
      </div>
    </div>
  );
}
